import useSWR from "swr";

import { fetcher } from "../services/config";
import { MethodType } from "../services/type";

export function useGetProfileImg(userId?: string) {
  const uri = userId ? `/mediamanager/userprofile/${userId}/image` : null;

  const {
    data: imageUrl,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(
    uri ? [uri, MethodType.GET] : null,
    ([url, method]) => fetcher<string>(url, method),
    {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 60 * 1000,
    },
  );

  return { imageUrl, error, isLoading, isValidating, mutate };
}
